var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Nav"},[_c('router-link',{attrs:{"to":"/English"}},[_c('img',{attrs:{"src":"img/logo2.jpg"}})]),_c('div',{staticClass:"Navigation-cut"},[_c('div',{staticClass:"Navigation-mane"},[_c('p',[_c('router-link',{attrs:{"to":"/pc"}},[_vm._v("中文")])],1),_c('p',{staticClass:"Navigation-mane-click"},[_vm._v("English")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }